export const LAYOUT_VARIANTS = {
  BORDERED_INNER_LABEL: 0,
  BORDERLESS_INNER_LABEL: 1,
};

export const VARIANTS_WITH_BORDER = [
  LAYOUT_VARIANTS.BORDERED_INNER_LABEL,
];



// WEBPACK FOOTER //
// ./src/components/Input/DropDown/constants.js